import utils from "../components/utils";

export default class ViewUtils {
    static _VIEWS_ = {};

    static getCrud = (name = 'main', args) => {
        const view = ViewUtils.getView();

        if (!view.cruds[name]) {
            view.cruds[name] = { changed: {}, data: {}, ...args };
        }
        return view.cruds[name];
    }
    static getView = () => {
        const path = window.location.pathname;

        if (!ViewUtils._VIEWS_[path]) {
            ViewUtils._VIEWS_[path] = { cruds: {}, ...window.view, root: window.view };
        }
        return ViewUtils._VIEWS_[path];
    }

    /**
     * Função utilitária para extrair colunas dos children
     */
    static collectParts(all, children, part) {
        if (!children || !part) return;

        // Inicializa apenas se ainda não existir
        if (!all[part]) {
            all[part] = {};
        }

        // Se for array → percorre corretamente
        if (Array.isArray(children)) {
            children.forEach((ch) => ViewUtils.collectParts(all, ch, part));
            return;
        }

        // Se for uma função (ex: render prop) → executa e processa o retorno
        if (typeof children === "function") {
            ViewUtils.collectParts(all, children(), part);
            return;
        }

        // Se não for elemento React válido → ignora
        if (typeof children !== "object" || !children.type) return;

        const child = children;

        // Normaliza type
        const typeName =
            typeof child.type === "string"
                ? child.type
                : child.type.name ||
                child.type.defaultType ||
                child.type.elementType ||
                child.type.type ||
                "";

        // Se for coluna
        if (typeName.toLowerCase() === "column") {
            const field = utils.nvl(child.props.field, child.props.name);

            if (field) {
                all[part][field] = {
                    ...child.props,
                };
                delete all[part][field].children;

                console.log("COLUNA ENCONTRADA:", field, all[part][field]);
            }
        }

        // Recursão em filhos
        if (child.props?.children) {
            ViewUtils.collectParts(all, child.props.children, part);
        }
    }

}